
export const WORK_DIRECTION = 'dt';